module.exports = __webpack_public_path__ + "static/media/number.00aaa791.svg";